<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Supervisores</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <base-button type="success" @click="crearSupervisor()">Crear Supervisor</base-button>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in supervisores"
                v-bind:key="item.AccountID"
                :value="item.AccountID"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-8" style="display: flex">
                  <span
                    style="margin-left: 10px;margin-top: 10px; font-size:42px;"
                    class="fa fa-fw fa-user"
                  />
                  <div style="margin-left: 10px;margin-top: 22px; margin-bottom:22px;">
                    <div>{{item.Name}} {{item.Surname}}({{item.UserName}})</div>
                  </div>
                </div>
                <div class="col-4 text-right" style="margin-top: 10px;">
                  <button
                    type="button"
                    @click="itemClicked(item)"
                    class="btn btn-primary"
                    style="border-bottom:10px;"
                  >
                    <!---->
                    <!---->
                    <!---->
                    <i class="fa fa-edit fa-fw"></i>Modificar
                  </button>
                  <button
                    v-if="item.Blocked"
                    type="button"
                    @click="desbloquearClicked(item)"
                    class="btn btn-danger"
                    style="border-bottom:10px;"
                  >
                    <!---->
                    <!---->
                    <!---->
                    <i class="fa fa-ban fa-fw"></i>Desbloquear
                  </button>
                  <button
                    type="button"
                    v-if="item.Active == false"
                    @click="enableSupervisorClicked(item.AccountID)"
                    class="btn btn-primary"
                    style="border-bottom:10px;background-color:green"
                  >
                    <!-- <i class="fa fa-check-circle fa-fw"></i> -->
                    Habilitar
                  </button>
                  <button
                    type="button"
                    v-if="item.Active"
                    @click="enableSupervisorClicked(item.AccountID)"
                    class="btn btn-primary"
                    style="border-bottom:10px;background-color:red"
                  >
                    <!-- <i class="fa fa-times-circle fa-fw"></i> -->
                    Deshabilitar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";

export default {
  components: { KitsCombo, KitsBusquedaSimple },
  data() {
    return {
      model: { Referencia: "", Importe: 0, Aux: "" },
      supervisores: [],
      supervisor: null
    };
  },
  methods: {
    crearSupervisor() {
      this.$router.push({
        name: "crearsupervisor",
        params: { EntityIDProp: 0 }
      });
    },
    itemClicked(item) {
      let self = this;
      self.$router.push({
        name: "crearsupervisor",
        params: { EntityIDProp: item.AccountID }
      });
    },
    desbloquearClicked(item) {
      let context = this;
      let selectedItem = item;
      notificationHelpers.showConfirmation(
        "Desbloquear supervisor",
        "Está seguro que desea desbloquear al supervisor?",
        function(data) {
          axiosHelpers.axiosPost(
            "Commerce/UnblockAccount",
            { AccountID: selectedItem.AccountID },
            context,
            function(data) {
              if (data.ResponseVM.Result) {
                notificationHelpers.showSuccess(
                  "Exito",
                  "Se desbloqueó el supervisor correctamente.",
                  context
                );

                context.cargar();
              }
            }
          );
        },
        null,
        context
      );
    },
    enableSupervisorClicked(accountID) {
      let context = this;
      axiosHelpers.axiosPost(
        "Commerce/EnableAccount",
        { AccountID: accountID },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            notificationHelpers.showSuccess(
              "Exito",
              "Operación realizada correctamente.",
              context
            );

            context.cargar();
          }
        }
      );
    },
    cargar() {
      let context = this;

      axiosHelpers.axiosGet(
        "Commerce/SupervisorManagementIndex",
        {},
        this,
        function(data) {
          context.supervisores = data.ResponseVM.Items;
        }
      );
    }
  },
  beforeMount: function() {
    this.cargar();
  }
};
</script>